import(/* webpackMode: "eager" */ "/vercel/path0/apps/ui/app-ui/src/app/(main)/site/[siteId]/[instanceId]/(docs)/error.tsx");
